<template>
    <div class="slider-default card-slider" v-if="sliderItems">
        <VueSlickCarousel
            ref="promo"
            v-bind="slickOptionsMain"
            class="slider card-slider__main"
            @beforeChange="syncSliders"
        >
            <div
                v-for="(sliderItem, i) of sliderItems"
                :key="i"
                @click="index = i"
            >
                <img
                    class="card-slider__main-img"
                    :src="sliderItem.full"
                    alt=""
                />
            </div>
            <template #prevArrow="arrowOption">
                <button type="button" class="slick-arrow _prev">
                    <svg class="icon-arrow">
                        <use xlink:href="#arrow-slider" />
                    </svg>
                </button>
            </template>
            <template #nextArrow="arrowOption">
                <button type="button" class="slick-arrow _next">
                    <svg class="icon-arrow">
                        <use xlink:href="#arrow-slider" />
                    </svg>
                </button>
            </template>
        </VueSlickCarousel>
        <vue-gallery-slideshow
            :images="sliderItemsImg"
            :index="index"
            @close="index = null"
        ></vue-gallery-slideshow>
        <VueSlickCarousel
            ref="img"
            v-bind="slickOptionsThumbs"
            @beforeChange="syncSliders"
            class="slider slider-carousel card-slider__thumbs"
        >
            <div v-for="(sliderItem, i) of sliderItems" :key="i">
                <img
                    class="card-slider__thumbs-img"
                    :src="sliderItem.thumb"
                    alt=""
                />
            </div>
        </VueSlickCarousel>
    </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
    name: 'sliderCard',
    props: ['id'],
    components: { VueSlickCarousel, VueGallerySlideshow },
    data() {
        return {
            index: null,
            slickOptionsMain: {
                arrows: true,
                lazyLoad: 'ondemand',
                asNavFor: this.$refs.img,
            },
            slickOptionsThumbs: {
                slidesToShow: 4,
                arrows: false,
                dots: true,
                focusOnSelect: true,
                lazyLoad: 'ondemand',
                asNavFor: this.$refs.promo,
            },
            sliderItems: null,
            sliderItemsImg: [],
        };
    },
    created() {
        this.$http.get('/api/products/' + this.id + '/gallery').then((res) => {
            this.sliderItems = res.data;
            let newObjects = this.sliderItems.map((obj) => {
                return {
                    url: obj.full,
                };
            });
            this.sliderItemsImg = newObjects;
        });
    },
    methods: {
        syncSliders(currentPosition, nextPosition) {
            this.$refs.img.goTo(nextPosition);
            this.$refs.promo.goTo(nextPosition);
        },
    },
};
</script>
